import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../hooks/use-encounter-creation-gate";
import {
  EncounterTemplateControllerApi,
  GetEncounterTemplateTemplateTypeEnum,
} from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  templateType?: GetEncounterTemplateTemplateTypeEnum;
  appointmentUuid?: string;
  xTENANTID?: string;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const useRosPeTemplateList = ({
  pagination,
  gridSorting,
  status,
  archive,
  templateType,
  appointmentUuid,
  xTENANTID,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "patient-ros-pe-template-list",
      xTENANTID,
      pageIndex,
      pagination.pageSize,
      gridSorting,
      sortDirect,
      sortBy,
      status,
      archive,
      templateType,
      appointmentUuid,
    ],
    enabled: !skip,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new EncounterTemplateControllerApi(getConfigObject())
        .getEncounterTemplate(
          pageIndex, //page
          pagination.pageSize, //size
          sortBy,
          sortDirect, // sortDirection
          status,
          archive,
          templateType,
          appointmentUuid,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
